/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_SubtitleInputs */

const vi_grower_area_qr_subtitle = /** @type {(inputs: Grower_Area_Qr_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung mã là số điện thoại hộ ghép liền mã vùng trồng`)
};

/**

* @param {Grower_Area_Qr_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_subtitle = /** @type {((inputs?: Grower_Area_Qr_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_subtitle(inputs)
});